import { useState } from 'react';
import { categories } from '@/mocks/movies';

interface CategoryTabsProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {categories.slice(0, 8).map((cat) => (
        <button
          key={cat.id}
          onClick={() => onCategoryChange(cat.slug)}
          className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap ${
            activeCategory === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-200 text-foreground-400 hover:text-foreground-200 hover:bg-background-300'
          }`}
        >
          {cat.name}
        </button>
      ))}
    </div>
  );
}